/* eslint-disable @typescript-eslint/no-explicit-any */
import { IGetData } from './get-data';

export class InitDb implements IGetData {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getData(payload: any, db?: any): any {
        const dbObject = {} as any;
        return dbObject;
    }
}
